module.exports = __webpack_public_path__ + "img/psnp3ww5dog9ew5z5nbte56sn3ehkdrnx2b1d4a04b8-d487-449d-b92c-797764320930.a59f9738.png";